// Season editor list, grouped by field. Pre season / Active rows show the block
// name; Archive rows are a Name | Crop | Season table (one row per archived
// season, newest first). Bulk mode adds "Select all" and a checkbox per row.
const React = require('react');
const { useTranslation } = require('react-i18next');
const { upper } = require('helpers');
const { SEASON_TABS, formatSeasonMonth } = require('./seasonHelpers');

const RowCheckbox = ({ checked, onToggle }) => (
  <input
    type='checkbox'
    className='ns-checkbox'
    checked={checked}
    onChange={onToggle}
    onClick={(event) => event.stopPropagation()}
  />
);

const rowClassName = (isSelected) =>
  'ns-season-row' + (isSelected ? ' ns-season-row-selected' : '');

const BlockSeasonRow = ({
  row,
  isSelected,
  bulkMode,
  isChecked,
  onSelect,
  onToggle,
}) => (
  <div className={rowClassName(isSelected)} onClick={() => onSelect(row.key)}>
    {bulkMode && (
      <RowCheckbox checked={isChecked} onToggle={() => onToggle(row.key)} />
    )}
    <span className='ns-season-name'>{row.block.name}</span>
  </div>
);

const ArchiveSeasonRow = ({
  row,
  isSelected,
  bulkMode,
  isChecked,
  onSelect,
  onToggle,
}) => {
  const { t } = useTranslation();
  const cropType = row.season?.crop_data?.crop_type;
  return (
    <div
      className={rowClassName(isSelected) + ' ns-archive-row'}
      onClick={() => onSelect(row.key)}
    >
      {bulkMode && (
        <RowCheckbox checked={isChecked} onToggle={() => onToggle(row.key)} />
      )}
      <span>{row.block.name}</span>
      <span>{cropType ? t(upper(String(cropType).toLowerCase())) : ''}</span>
      <span>{formatSeasonMonth(row.season?.crop_data?.sow_date)}</span>
    </div>
  );
};

const ArchiveHeader = ({ bulkMode }) => {
  const { t } = useTranslation();
  return (
    <div className='ns-archive-row ns-archive-header'>
      {bulkMode && <span className='ns-checkbox-spacer' />}
      <span>{t('name')}</span>
      <span>{t('new_season_crop')}</span>
      <span>{t('season')}</span>
    </div>
  );
};

const SeasonList = ({
  tab,
  groups,
  selectedKey,
  bulkMode,
  checkedKeys,
  onSelect,
  onToggle,
  onToggleAll,
}) => {
  const { t } = useTranslation();
  const checked = new Set(checkedKeys);
  const totalRows = groups.reduce(
    (count, group) => count + group.rows.length,
    0,
  );
  const RowComponent =
    tab === SEASON_TABS.ARCHIVE ? ArchiveSeasonRow : BlockSeasonRow;

  if (totalRows === 0) {
    return <div className='ns-empty-text'>{t('new_season_no_seasons')}</div>;
  }
  return (
    <div className='ns-season-list'>
      {bulkMode && (
        <label className='ns-select-all'>
          <input
            type='checkbox'
            className='ns-checkbox'
            checked={checked.size === totalRows}
            onChange={onToggleAll}
          />
          {t('select_all')}
        </label>
      )}
      {tab === SEASON_TABS.ARCHIVE && <ArchiveHeader bulkMode={bulkMode} />}
      {groups.map((group) => (
        <div key={group.fieldGroup.id} className='ns-season-group'>
          {group.showHeader && (
            <div className='ns-season-group-title'>{group.fieldGroup.name}</div>
          )}
          {group.rows.map((row) => (
            <RowComponent
              key={row.key}
              row={row}
              isSelected={
                bulkMode ? checked.has(row.key) : row.key === selectedKey
              }
              bulkMode={bulkMode}
              isChecked={checked.has(row.key)}
              onSelect={bulkMode ? onToggle : onSelect}
              onToggle={onToggle}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

module.exports = SeasonList;
